import React from 'react';
import { useNavigate } from 'react-router';
import { equipmentTypeFieldSchema } from '../../../../../common/src/domain/drone/equipment/equipmentSchemas';
import { useTranslate } from '../../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    Panel,
    PanelBody,
    PanelButton,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../../elements';
import { ValidatingEditPanelSaveButton, ValidatingCulturedFormInputNumber, ValidatingForm, ValidatingFormInputText } from '../../validatingElements';

export function EquipmentTypeFieldAddEdit(props: { params: { equipmentTypeId: string; equipmentTypeFieldId?: string } }) {
    const { equipmentTypeId, equipmentTypeFieldId } = props.params;
    const translate = useTranslate();
    const navigate = useNavigate();

    // eslint-disable-next-line @typescript-eslint/require-await
    async function handleSavedOrCancelled() {
        navigate(`/settings/equipmenttypes/${equipmentTypeId}/fields`);
    }

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    {(equipmentTypeFieldId && (
                        <TopbarCrumbActive title={translate('common.editItem', translate('equipment.customFields'))} icon="fa-cogs" />
                    )) || <TopbarCrumbActive title={translate('common.addItem', translate('equipment.customFields'))} icon="fa-cogs" />}
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small>
                        <PanelBody noPadding>
                            <ValidatingForm
                                schema={equipmentTypeFieldSchema}
                                createUrl={`/api/equipmentTypes/${equipmentTypeId}/fields`}
                                updateUrl={`/api/equipmentTypes/${equipmentTypeId}/fields/${equipmentTypeFieldId}`}
                                itemUrl={`/api/equipmentTypes/${equipmentTypeId}/fields/${equipmentTypeFieldId}`}
                                id={equipmentTypeFieldId}
                                onSubmitted={handleSavedOrCancelled}
                            >
                                <EditPanel>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <ValidatingFormInputText name="name" topLabel={translate('equipment.fieldName')} autoFocus />
                                        </EditPanelCell>
                                        <EditPanelCell rowCount={6}>
                                            <ValidatingCulturedFormInputNumber name="fieldOrder" topLabel={translate('equipment.fieldOrder')} />
                                        </EditPanelCell>
                                    </EditPanelRow>
                                </EditPanel>
                                <EditPanelButtons footer>
                                    <PanelButton text={translate('common.cancel')} onClick={handleSavedOrCancelled} />
                                    <ValidatingEditPanelSaveButton />
                                </EditPanelButtons>
                            </ValidatingForm>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
